module.exports = __webpack_public_path__ + "static/media/toast-fail.d3684d86.svg";